module.exports = __webpack_public_path__ + "static/scale-model-of-chattanooga-tennessee-add8c60fe53654f79be0157ac7056703.png";